import React from 'react';
import xss, { friendlyAttrValue, safeAttrValue as XssSafeAttrValue, } from 'xss';
function safeAttrValue(tag, name, value, cssFilter) {
    if (name === 'href') {
        const friendlyValue = friendlyAttrValue(value);
        if (friendlyValue.startsWith('${') && friendlyValue.indexOf('}') !== -1) {
            return value;
        }
    }
    return XssSafeAttrValue(tag, name, value, cssFilter);
}
export const SecureHtml = React.memo(function ({ html, containerProps, as: Component = 'div', skipCleaning, }) {
    let cleanHtml;
    if (skipCleaning) {
        cleanHtml = html;
    }
    else {
        cleanHtml = xss(html, {
            allowList: {
                h1: ['style', 'dir', 'class'],
                h2: ['style', 'dir', 'class'],
                h3: ['style', 'dir', 'class'],
                div: ['style', 'dir', 'class'],
                span: ['style', 'dir', 'class'],
                p: ['style', 'dir', 'class'],
                a: ['style', 'dir', 'target', 'rel', 'href'],
                ol: ['style', 'dir', 'class', 'start'],
                ul: ['style', 'dir', 'class'],
                li: ['style', 'dir', 'class'],
                comment: [],
                s: [],
                b: [],
                i: [],
                u: [],
                bdi: ['style', 'dir'],
                br: [],
                pre: [],
                strong: [],
                em: [],
            },
            css: false,
            safeAttrValue,
        });
    }
    return (React.createElement(Component, { ...containerProps, dangerouslySetInnerHTML: { __html: cleanHtml } }));
});
//# sourceMappingURL=SecureHtml.js.map